import { NgModule } from '@angular/core';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { SelectDropdownComponent } from './select-dropdown.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [SelectDropdownComponent],
  imports: [
    SelectDropDownModule,
    MatIconModule
  ],
  exports: [SelectDropdownComponent],
  providers: [],
})
export class SelectDropdownModule { }
